import firebase from "firebase/app";
import fc from "@/firebaseConfig";

const axios = require("axios");
const _ = require('lodash');

export default async function createCompany(companyObject, dispatch, disableUploadLogo = false) {
  let user = firebase.auth().currentUser;
  let company = _.cloneDeep(companyObject)
  let companyId = ''
  company.sendEmailType = 0
  company.addUserPermission = "owner"
  delete company.logo

  // get user token
  let token = await user.getIdToken(/* forceRefresh */ false)
    .then(function (idToken) {
      return idToken
    });
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': 'JWT ' + token
  }

  let data = {
    company: company,
    logo: companyObject.logo
  }

  await axios.post(fc.cloudFunctionUrl + "createNewCompany", data, {headers})
    .then((response) => {
      if (response.status === 200 && !disableUploadLogo) {
        dispatch('companies/updateCompanyLogo', {
          logo: companyObject.logo,
          companyID: response.data,
          userID: user.uid
        })
      }
      companyId = response.data
    }, (error) => {
      console.log("error", error)
    });
  return companyId
}
